import * as React from "react";
import { Box, Modal, styled } from "@mui/material";
import { SimpleCard } from "app/components";
import CustomButton from "app/components/Button";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { useTheme } from "@mui/material";
import { format } from "date-fns";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Icon,
  IconButton,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Input,
  Backdrop,
  CircularProgress,
  Grid,
  Popper,
} from "@mui/material";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LoadingButton } from "@mui/lab";
import TextField from "@mui/material/TextField";
import { Span } from "app/components/Typography";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import CardActions from "@mui/material/CardActions";
import Typography from "@mui/material/Typography";
import * as XLSX from "xlsx";
import * as FileSaver from "file-saver";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import { differenceInDays, isSameDay } from "date-fns";
import Divider from "@mui/material/Divider";
import moment from "moment";
import Autocomplete from "@mui/material/Autocomplete";
import { GetComplienceReport } from "app/services/Services";
import Checkbox from "@mui/material/Checkbox";
import useEmpList from "app/hooks/useEmpList";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import LeaveTypeChart from "./LeaveTypeChart";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import { getEmployeeLeaveReport } from "app/services/LeaveManagement";
import {
  generateErrorMessage,
  generateSuccessMessage,
} from "app/utils/GenerateMessage";

import {
  convertedDate,
  attendanceConvertedDate,
  convertedDateToMonthyearFormat2,
  errorMessage2,
} from "app/utils/utils";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import Datefilter from "app/components/Datefilter";
import EmployeeLeaveReportDetails from "./EmployeeLeaveReportDetails";
import { set } from "lodash";

const AutoComplete = styled(Autocomplete)(() => ({
  width: "100%",
}));

const Label = styled("span")({
  fontWeight: "bold",
  color: "#666",
  fontSize: "12px",
});

const ValueLeave = styled("div")({
  fontSize: "12px",
  margin: 0, // Remove any default margins
});

const CenteredDivider = styled("hr")({
  margin: "auto",
  width: "80%",
  backgroundColor: "blue",
  marginBottom: 16,
});

const StyledTextArea = styled(TextareaAutosize)`
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 16px;
  resize: vertical;
`;
const Container = styled("div")(({ theme }) => ({
  // margin: "30px",
  [theme.breakpoints.down("sm")]: { margin: "16px" },
  "& .breadcrumb": {
    marginBottom: "30px",
    [theme.breakpoints.down("sm")]: { marginBottom: "16px" },
  },
}));
const Title = styled("span")(() => ({
  fontSize: "1.2rem",
  fontWeight: "600",
  textTransform: "capitalize",
}));
const CardHeader = styled(Box)(() => ({
  display: "flex",
  paddingLeft: "24px",
  paddingRight: "24px",
  marginBottom: "12px",
  alignItems: "center",
  justifyContent: "space-between",
}));
const StyledTextField = styled(TextField)(() => ({
  width: "100%",
  marginBottom: "16px",
}));

const StyledTable = styled(Table)(() => ({
  whiteSpace: "pre",
  "& thead": {
    "& tr": { "& th": { paddingLeft: 0, paddingRight: 0 } },
  },
  "& tbody": {
    "& tr": { "& td": { paddingLeft: 0, textTransform: "capitalize" } },
  },
}));
const StyledButton = styled(Button)(({ theme }) => ({
  margin: theme.spacing(1),
}));

const LeaveStatusList = [
  {
    status: "Pending",
  },
  {
    status: "Approved",
  },
  {
    status: "Rejected",
  },
  {
    status: "Canceled-by-Admin",
  },
  {
    status: "Canceled-by-Supervisor",
  },
  {
    status: "Approved-by-Supervisor",
  },
  {
    status: "Rejected-by-Supervisor",
  },
];

const LeaveReport = () => {
  const monthDateFormate = moment(today)
    .subtract(1, "days")
    .format("YYYY-MM-DD");
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [search, setSearch] = useState(null);
  const [complienceStatus, setComplienceStatus] = useState("");
  const { palette } = useTheme();
  const [empId, setEmpId] = useState(null);
  const navigate = useNavigate();
  const [selectedLeaveRequests, setSelectedLeaveRequests] = useState([]);
  const location = useLocation();
  const state = useEmpList();
  const { getEmployeeList } = useEmpList();
  const { employeeList } = state;
  const [error, setError] = useState(null);
  const [error2, setError2] = useState(null);
  const [date, setDate] = useState(monthDateFormate);
  const [month, setMonth] = useState();
  const [disableButton, setDisableButton] = useState(false);
  const [canceledLeaveModel, setCanceledLeaveModel] = useState(false);
  const [approvalLeaveModel, setApprovalLeaveModel] = useState(false);
  const [confirmDilogeBox, setconfirmDilogeBox] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null); // Tracks the displayed date
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [currentMonth, setCurrentMonth] = useState(
    moment(new Date()).format("MM-yyyy")
  );
  const [loader, setLoader] = useState(false);
  const [getLeaveRequestList, setLeaveRequestList] = useState([]);
  const [getEmployeeLeaveBalanceList, setEmployeeLeaveBalanceList] = useState(
    []
  );
  const [getsetLeaveRequestListCount, setLeaveRequestListCount] = useState([]);
  const [loading, setLoading] = useState(false);

  const [searchEmployee, setSearchEmployee] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const today = new Date();
  const CurentMonth = moment(today).format("YYYY-MM");
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [getSearchEmployeeId, setSearchEmployeeId] = useState(null);
  const [dateFieldError, setDateFieldError] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [empName, setEmpName] = useState(null);
  const [selectedStatusValue, setSelectedStatusValue] = useState(null);
  const initialDate = null;
  const initialSelectedDate = null;
  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "white",
    width: "70%",
    boxShadow: 24,
    p: 3,
    borderRadius: "10px",
  };
  let employeeLeaveTypeData = [];

  // const handleDate = (val) => {
  //   setPage(0);
  //   const formattedDate = attendanceConvertedDate(val);

  //   setDate(formattedDate);
  //   setFromDate(formattedDate);
  // };
  const handleDate = (newVal) => {
    setPage(0); // Added to match handleDate structure
    const formattedDate = attendanceConvertedDate(newVal);
    setFromDate(formattedDate);
  };

  const handleDateChange = (newVal) => {
    setPage(0); // Added to match handleDate structure
    const formattedDate = attendanceConvertedDate(newVal);
    setSelectedDate(new Date(newVal)); // Update displayed date
    setDate(formattedDate);
    setToDate(formattedDate);
  };

  const ExportToExcel = () => {
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    const fileName =
      `Leave Report_${search ? search : ""}` +
      "_" +
      `${complienceStatus ? complienceStatus : ""}` +
      "_" +
      `${
        date
          ? moment(date).format("DD-MM-yyyy")
          : month
          ? moment(month).format("MM-yyyy")
          : ""
      }`;

    const exportToCSV = () => {
      setLoader(true);
      if (error === "invalidDate" || error2 === "invalidDate") {
        setLoader(false);
        return;
      }
      const params = {
        page: `${page + 1}`,
        limit: rowsPerPage,
        name: empName,
        export: true,
        startFrom: fromDate,
        endTo: toDate,
      };
      getEmployeeLeaveReport(params)
        .then((res) => {
          if (res) {
            setLoader(false);
            if (res.status === 200) {
              if (month != null && value != null && value != "all") {
                let exportData = getLeaveRequestList?.map((object) => {
                  const copy = { ...object };
                  return copy;
                });

                const transformedExportData = exportData.map(
                  ({
                    employeeName,
                    leaveTypeName,
                    leaveDays,
                    leaveStatus,
                  }) => ({
                    Id: empId,
                    Name: employeeName,
                    Leave_Type: leaveTypeName,
                    Total_Leave_Count: leaveDays,
                    Status: leaveStatus,
                  })
                );
                const ws = XLSX.utils.json_to_sheet(transformedExportData);
                const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
                const excelBuffer = XLSX.write(wb, {
                  bookType: "xlsx",
                  type: "array",
                });
                const data = new Blob([excelBuffer], { type: fileType });
                FileSaver.saveAs(data, fileName + fileExtension);
              } else if (month != null && value == "all") {
                let exportData = getLeaveRequestList?.map((object) => {
                  const copy = { ...object };
                });
                const transformedExportData = exportData.map(
                  ({
                    empId,
                    employeeName,
                    leaveTypeName,
                    leaveDays,
                    leaveStatus,
                  }) => ({
                    Id: empId,
                    Name: employeeName,
                    Leave_Type: leaveTypeName,
                    Total_Leave_Count: leaveDays,
                    Status: leaveStatus,
                  })
                );
                const ws = XLSX.utils.json_to_sheet(transformedExportData);
                const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
                const excelBuffer = XLSX.write(wb, {
                  bookType: "xlsx",
                  type: "array",
                });
                const data = new Blob([excelBuffer], { type: fileType });
                FileSaver.saveAs(data, fileName + fileExtension);
              } else if (month != null) {
                let exportData = getLeaveRequestList?.map((object) => {
                  const copy = { ...object };
                  return copy;
                });
                const transformedExportData = exportData.map(
                  ({
                    empId,
                    employeeName,
                    leaveTypeName,
                    leaveDays,
                    leaveStatus,
                  }) => ({
                    Id: empId,
                    Name: employeeName,
                    Leave_Type: leaveTypeName,
                    Total_Leave_Count: leaveDays,
                    Status: leaveStatus,
                  })
                );
                const ws = XLSX.utils.json_to_sheet(transformedExportData);
                const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
                const excelBuffer = XLSX.write(wb, {
                  bookType: "xlsx",
                  type: "array",
                });
                const data = new Blob([excelBuffer], { type: fileType });
                FileSaver.saveAs(data, fileName + fileExtension);
              } else if (date != null) {
                let exportData = getLeaveRequestList?.map((object) => {
                  const copy = { ...object };
                  return copy;
                });

                const transformedExportData = exportData.map(
                  ({
                    empId,
                    employeeName,
                    leaveTypeName,
                    leaveDays,
                    leaveStatus,
                  }) => ({
                    Id: empId,
                    Name: employeeName,
                    Leave_Type: leaveTypeName,
                    Total_Leave_Count: leaveDays,
                    Status: leaveStatus,
                  })
                );

                const ws = XLSX.utils.json_to_sheet(transformedExportData);
                const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
                const excelBuffer = XLSX.write(wb, {
                  bookType: "xlsx",
                  type: "array",
                });
                const data = new Blob([excelBuffer], { type: fileType });
                FileSaver.saveAs(data, fileName + fileExtension);
              }
            }
          } else {
            setLoader(false);
            generateErrorMessage(`${"Something went wrong."}`);
          }
        })
        .catch((error) => {
          setLoader(false);
          generateErrorMessage(`${error?.response?.data?.message || ""}`);
        });
    };

    return (
      <StyledButton
        variant="contained"
        color="primary"
        startIcon={<SaveAltIcon />}
        onClick={(e) => {
          exportToCSV();
        }}
        disabled={disableButton ? true : false}
      >
        Export
      </StyledButton>
    );
  };

  const handleClick = (selectedEmployee) => {
    const { employeeName, leaveStatus, leaveTypeName } = selectedEmployee;
    const filteredRequests = getLeaveRequestList
      .filter(
        (emp) =>
          emp?.employeeName === employeeName &&
          emp?.leaveStatus === leaveStatus &&
          emp?.leaveTypeName === leaveTypeName
      )
      .flatMap((emp) => emp?.leaveRequests ?? []);
    setSelectedLeaveRequests(filteredRequests);
    setOpen(true);
  };

  const handleCancaledLeaveModel = () => {
    setCanceledLeaveModel(true);
  };
  const handleOpenApprovalModel = () => {
    setApprovalLeaveModel(true);
  };
  const handleOpenfirmDilogeBox = () => {
    setconfirmDilogeBox(true);
  };
  const handleCloseOpenLeaveModel = () => {
    setCanceledLeaveModel(false);
  };
  const handleCloseOpenEditLeaveModel = () => {
    setApprovalLeaveModel(false);
  };

  const handleCloseconfirmDilogeBox = () => {
    setApprovalLeaveModel(false);
    setCanceledLeaveModel(false);
  };

  const handleSubmitRecordDelete = () => {};

  const applyLeave = () => {};

  const generateColor = (id) => {
    return `hsl(0, 0%, ${5 * 10}%)`;
  };

  useEffect(() => {
    getEmployeeList();
  }, []);

  const [value, setValue] = React.useState("1");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangePage = (_e, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  // const Submit = () => {
  //   const params = {
  //     page: `${page + 1}`,
  //     limit: rowsPerPage,
  //     name: empName,
  //     startFrom: fromDate,
  //     endTo: toDate,
  //   };

  //   setLoading(true); // Ensure loading starts before API call

  //   getEmployeeLeaveReport(params)
  //     .then((res) => {
  //       setLoading(false);

  //       if (res.status === 200) {
  //         if (res?.data?.leaveRequestList.length === 0) {
  //           setLeaveRequestListCount(0);
  //           setLeaveRequestList([]);
  //           setEmployeeLeaveBalanceList([]);
  //         } else {
  //           setLeaveRequestListCount(res?.data?.leaveRequestCount);
  //           setLeaveRequestList(res?.data?.leaveRequestList);

  //           if (getSearchEmployeeId != null) {
  //             setEmployeeLeaveBalanceList(res?.data?.employeeLeaveBalance);
  //           } else {
  //             setEmployeeLeaveBalanceList([]);
  //           }
  //         }
  //       }
  //     })
  //     .catch((error) => {
  //       setLoading(false);
  //       console.error("API Error:", error); //
  //     });
  // };

  const getAllLeaveReportList = () => {
    setLoading(true);
    let params = {
      page: `${page + 1}`,
      limit: rowsPerPage,
      leaveDate: selectedMonth ? moment(selectedMonth).format("YYYY-MM") : null,
      employeeId: getSearchEmployeeId,
      leaveStatus: selectedStatusValue,
      startFrom: fromDate,
      endTo: toDate,
    };
    getEmployeeLeaveReport(params)
      .then((res) => {
        setLoading(false);
        if (res.status === 200) {
          if (res?.data?.leaveRequestList.length === 0) {
            setLeaveRequestListCount();
            setLeaveRequestList([]);
            setEmployeeLeaveBalanceList([]);
          } else {
            setLeaveRequestListCount(res?.data?.leaveRequestCount);
            setLeaveRequestList(res?.data?.leaveRequestList);
            if (getSearchEmployeeId != null) {
              setEmployeeLeaveBalanceList(res?.data?.employeeLeaveBalance);
            } else {
              setEmployeeLeaveBalanceList([]);
            }
          }
        }
      })
      .catch((error) => {
        setEmployeeLeaveBalanceList([]);
        setLeaveRequestListCount();
        setLeaveRequestList([]);
        setLoading(false);
        generateErrorMessage(`${error?.response?.data?.message || ""}`);
      });
  };

  useEffect(() => {
    getAllLeaveReportList();
  }, [
    page,
    rowsPerPage,
    location,
    selectedMonth,
    searchEmployee,
    selectedStatus,
    selectedStatusValue,
    fromDate,
    toDate,
  ]);

  const handleReset = () => {
    const today = new Date();
    setSearchEmployeeId(null);
    setSearchEmployee(null);
    setSelectedMonth();
    setEmployeeLeaveBalanceList([]);
    setSelectedStatusValue(null);
    setSelectedStatus(null);
    setDate(initialDate);
    setSelectedDate(initialSelectedDate);
    setFromDate(null);
    setToDate(null);
  };

  useEffect(() => {
    const { hostname } = window.location;
    document.title = `${hostname} | Leave Report `;
  }, []);

  const isFilterApplied = () => {
    return (
      selectedMonth ||
      searchEmployee ||
      fromDate ||
      toDate
    );
  };

  const getLeaveColor = () => {
    if (isFilterApplied()) {
      return { color: 'blue', cursor: 'pointer',fontWeight:600 }; 
    }
    return {  cursor: 'not-allowed' };
  };

  return (
    <Container>
      <SimpleCard>
        <Box width="100%">
          <Grid container spacing={2} alignItems="center" sx={{ mt: 0, mb: 2 }}>
            {/* Leave Status */}
            <Grid item lg={3} md={3} sm={12} xs={12}>
              <Autocomplete
                value={selectedStatus}
                id="leaveStatus"
                options={LeaveStatusList}
                getOptionLabel={(option) => option?.status || ""}
                isOptionEqualToValue={(option, value) =>
                  option.status === value.status
                }
                renderOption={(props, option) => (
                  <li {...props} key={option.status}>
                    {option.status}
                  </li>
                )}
                onChange={(event, newValue) => {
                  setSelectedStatus(newValue);
                  setSelectedStatusValue(newValue?.status);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Leave Status"
                    variant="standard"
                  />
                )}
                fullWidth
              />
            </Grid>

            {/* Employee Name */}
            <Grid item lg={3} md={3} sm={12} xs={12}>
              <Autocomplete
                value={searchEmployee}
                id="employeeName"
                getOptionLabel={(employeeList) =>
                  employeeList.firstName || employeeList
                }
                options={employeeList}
                renderOption={(props, option) => (
                  <li {...props} key={`${option.firstName}+${option.userId}`}>
                    {option.firstName}
                  </li>
                )}
                onChange={(event, val) => {
                  if (val === null) {
                    setSearchEmployee(null);
                    setSearchEmployeeId(null);
                  } else {
                    const { userId, firstName } = val || {};
                    setSearchEmployee(firstName);
                    setSearchEmployeeId(userId);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Employee Name"
                    variant="standard"
                  />
                )}
                fullWidth
              />
            </Grid>

            {/* Date From */}
            <Grid item lg={3} md={3} sm={6} xs={12}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  format="dd/MM/yyyy"
                  value={!!fromDate ? new Date(fromDate) : null}
                  openTo="day"
                  views={["year", "month", "day"]}
                  onError={(newError) => setError(newError)}
                  label="From"
                  slotProps={{
                    textField: {
                      variant: "standard",
                      helperText: error2,
                      onChange: (newVal, validate) => {
                        const { validationError } = validate || {};
                        if (validationError) {
                          setError2(validationError);
                        } else {
                          setError2("");
                          handleDate(newVal);
                        }
                      },
                    },
                  }}
                  onAccept={(newVal) => handleDate(newVal)}
                  disabled={error2 === "invalidDate"}
                />
              </LocalizationProvider>
            </Grid>

            {/* Date To */}
            <Grid
              item
              lg={3}
              md={3}
              sm={6}
              xs={12}
              sx={{ position: "relative" }}
            >
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  format="dd/MM/yyyy"
                  value={selectedDate}
                  onError={(newError) => setError2(newError)}
                  openTo="day"
                  views={["year", "month", "day"]}
                  label="To"
                  slotProps={{
                    textField: {
                      variant: "standard",
                      helperText: error2,
                      onChange: (newVal, validate) => {
                        const { validationError } = validate || {};
                        if (validationError) {
                          setError2(validationError);
                        } else {
                          setError2("");
                          handleDateChange(newVal);
                        }
                      },
                    },
                  }}
                  onAccept={(newVal) => handleDateChange(newVal)}
                  disabled={error2 === "invalidDate"}
                />
              </LocalizationProvider>
            </Grid>
          </Grid>
          <Grid container spacing={2} alignItems="center" sx={{ mt: 0, mb: 2 }}>
            <Grid
              item
              lg={4}
              md={4}
              sm={6}
              xs={12}
              display="flex"
              justifyContent="flex-start"
            >
              {/* <CustomButton
                variant="contained"
                onClick={Submit}
                icon={<RestartAltIcon />}
                fullWidth
                sx={{ backgroundColor: "#1976D2", color: "#fff" }}
              >
                Submit
              </CustomButton> */}
              <ExportToExcel
                variant="contained"
                color="primary"
                sx={{ marginRight: 1 }}
              />
              <CustomButton
                variant="outlined"
                onClick={handleReset}
                icon={<RestartAltIcon />}
                fullWidth
              >
                Reset
              </CustomButton>
            </Grid>
          </Grid>
        </Box>

        {getLeaveRequestList?.length > 0 ? (
          <Box width="100%" overflow="auto">
            <TableContainer>
              <StyledTable sx={{ minWidth: 870 }}>
                <TableHead>
                  <TableRow>
                    <TableCell align="center">Name</TableCell>
                    <TableCell align="center">Leave Type</TableCell>
                    <TableCell align="center">Leave Count</TableCell>
                    <TableCell align="center">Status</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {getLeaveRequestList.map((val, index) => (
                    <TableRow key={index}>
                      <TableCell align="center">{val.employeeName}</TableCell>
                      <TableCell align="center">{val.leaveTypeName}</TableCell>
                      <TableCell align="center">
                        <Typography
                          onClick={() => isFilterApplied() && handleClick(val)}
                          style={{
                            ...getLeaveColor(),  // Apply conditional styles for color and cursor
                            fontWeight: "normal",
                            transition: "color 0.3s ease, font-weight 0.3s ease",
                          }}
                        >
                          {val.leaveDays}
                        </Typography>
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{
                          color:
                            val.leaveStatus === "Approved"
                              ? "green"
                              : val.leaveStatus === "Rejected"
                              ? "red"
                              : val.leaveStatus === "Canceled"
                              ? "orange"
                              : "black",
                        }}
                      >
                        {val.leaveStatus.includes("Canceled-by") ? (
                          <span style={{ color: "orange" }}>
                            {val.leaveStatus.replace("-", " ")}
                          </span>
                        ) : val.leaveStatus.includes("Approved-by") ? (
                          <span style={{ color: "green" }}>
                            {val.leaveStatus.replace("-", " ")}
                          </span>
                        ) : val.leaveStatus.includes("Rejected-by") ? (
                          <span style={{ color: "red" }}>
                            {val.leaveStatus.replace("-", " ")}
                          </span>
                        ) : (
                          val.leaveStatus
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </StyledTable>
            </TableContainer>

            <TablePagination
              className="pagination-container"
              classes={{
                select: "pagination-select",
                actions: "pagination-actions",
              }}
              sx={{ px: 2 }}
              page={page}
              component="div"
              rowsPerPage={rowsPerPage}
              count={getsetLeaveRequestListCount}
              onPageChange={handleChangePage}
              rowsPerPageOptions={[10, 25, 50]}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Box>
        ) : (
          !loader && (
            <p
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              No data available!
            </p>
          )
        )}

        <Modal open={open} onClose={handleClose}>
          <Box sx={modalStyle}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              mb={2}
            >
              <Typography variant="h6" fontWeight="bold">
                Leave Reports
              </Typography>
              <IconButton onClick={handleClose} sx={{ color: "gray" }}>
                <CloseIcon />
              </IconButton>
            </Box>
            <EmployeeLeaveReportDetails data={selectedLeaveRequests} />
          </Box>
        </Modal>
      </SimpleCard>
    </Container>
  );
};

export default LeaveReport;
